import React from "react";
import Yoghurt from "./yogurt.png";
import Weather from "./weather.png";
import Yoga from "./yoga.png";

export default function Work() {
  return (
    <div>
      <div className="row gx-5 py-5 justify-content-center">
        <h1 id="Work" className="text-center py-4">
          My work
        </h1>
        <div className="col-lg-5 col-sm-12">
          <img src={Yoga} className="img-fluid d-none d-sm-block" alt="yoga" />
        </div>
        <div className="col-lg-5 col-sm-12">
          <h2>Yoga app</h2>
          <p className="fs-4">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad totam
            facere, maiores quis ipsam molestiae omnis animi consequatur iusto
            enim aliquid? Velit harum sapiente provident tenetur eligendi
            officiis eveniet in.
          </p>
          <button type="button" className="btn btn-outline-info">
            Launch yoga app
          </button>
        </div>
      </div>
      <div className="row gx-5 py-5 justify-content-center">
        <div className="col-lg-5 col-sm-12">
          <h2>Weather app</h2>
          <p className="fs-4">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo iste
            quos, facere ab doloremque provident sequi magnam dolore minus.
            Repellendus facere aperiam consectetur illum adipisci perferendis
            eaque eligendi, sequi quaerat.
          </p>
          <button type="button" className="btn btn-outline-info">
            Launch Weather app
          </button>
        </div>
        <div className="col-lg-5 col-sm-12">
          <img
            src={Weather}
            className="img-fluid d-none d-sm-block"
            alt="weather app"
          />
        </div>
      </div>
      <div className="row gx-5 py-5 justify-content-center">
        <div className="col-lg-5 col-sm-12">
          <img
            src={Yoghurt}
            className="img-fluid d-none d-sm-block"
            alt="Love for yoghurt"
          />
        </div>
        <div className="col-lg-5 col-sm-12">
          <h2>Yoghurt site</h2>
          <p className="fs-4">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
            delectus, at, soluta debitis sint molestias quia modi atque quasi
            facilis voluptates et adipisci velit voluptatem accusamus ea
            distinctio, animi facere.
          </p>
          <button type="button" className="btn btn-outline-info">
            Launch yoghurt site
          </button>
        </div>
      </div>
    </div>
  );
}
